import './component';
import './preview';

Shopware.Service('cmsService').registerCmsBlock({
    name: 'acris-blog',
    label: 'acris-blog.blocks.blog.label',
    category: 'acris-blog',
    component: 'sw-cms-block-acris-blog',
    previewComponent: 'sw-cms-preview-acris-blog',
    defaultConfig: {
        marginBottom: '20px',
        marginTop: '20px',
        marginLeft: '20px',
        marginRight: '20px',
        sizingMode: 'boxed'
    },
    slots: {
        column: {
            type: 'acris-blog-group'
        },
    }
});
